import React, { memo } from 'react';
import { GraduationCap, ClipboardList, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const masterclassItems = ['Entendé cómo funciona tu negocio sin depender de tu memoria', 'Hacé que el trabajo avance sin mirar cada paso', 'Dejá de repetir las mismas tareas una y otra vez', 'Detectá qué tareas te hacen perder tiempo', 'Entendé por qué algunos meses facturás bien y otros no'];
const guideItems = ['Mapeá cómo trabajás hoy con plantillas simples', 'Encontrá dónde se traba tu trabajo', 'Definí quién hace cada tarea y cuándo', 'Seguí un checklist semanal para empezar'];
export function ProductPresentation() {
  return <section id="contenido" className="bg-brand-lighter px-6 py-24 lg:px-8" data-id="element-217">
      <div className="mx-auto max-w-6xl" data-id="element-218">
        <motion.header initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto mb-14 max-w-3xl text-center" data-id="element-219">
          <h2 className="text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-220">
            Ordená tus tareas y hablá de precio con claridad
          </h2>
          <p className="mt-4 text-lg text-brand-navy/70 md:text-xl" data-id="element-221">
            Tenés una clase y una guía para aplicar desde el primer día.
          </p>
        </motion.header>

        <div className="grid gap-8 lg:grid-cols-2" data-id="element-222">
          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-3xl border border-brand-light bg-white p-7 shadow-soft md:p-9" data-id="element-223">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-accent/10" data-id="element-224">
              <GraduationCap className="h-6 w-6 text-brand-accent" data-id="element-225" />
            </div>
            <p className="mb-2 text-xs font-extrabold uppercase tracking-[0.16em] text-brand-accent" data-id="element-226">
              Masterclass
            </p>
            <h3 className="mb-3 text-2xl font-extrabold text-brand-navy" data-id="element-227">
              Cómo ordenar tu negocio
            </h3>
            <p className="mb-6 text-brand-navy/70" data-id="element-228">
              Mirá qué cambiar y empezá por lo importante.
            </p>
            <ul className="space-y-4" data-id="element-229">
              {masterclassItems.map(item => <li key={item} className="flex items-start gap-3 text-brand-navy/80" data-id="element-230">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-231" />
                  {item}
                </li>)}
            </ul>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} className="rounded-3xl border border-brand-light bg-white p-7 shadow-soft md:p-9" data-id="element-232">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-accent/10" data-id="element-233">
              <ClipboardList className="h-6 w-6 text-brand-accent" data-id="element-234" />
            </div>
            <p className="mb-2 text-xs font-extrabold uppercase tracking-[0.16em] text-brand-accent" data-id="element-235">
              Guía práctica
            </p>
            <h3 className="mb-3 text-2xl font-extrabold text-brand-navy" data-id="element-236">
              Aplicá los cambios paso a paso
            </h3>
            <p className="mb-6 text-brand-navy/70" data-id="element-237">
              Usá herramientas simples para ordenar tu forma de trabajar.
            </p>
            <ul className="space-y-4" data-id="element-238">
              {guideItems.map(item => <li key={item} className="flex items-start gap-3 text-brand-navy/80" data-id="element-239">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-240" />
                  {item}
                </li>)}
            </ul>
          </motion.article>
        </div>
      </div>
    </section>;
}